export const GET_TOP_QUERY = `query GetTopCategoriesAndBrands ($geo: GeoInputType!, $timePeriod: TimePeriod!)  {
  categories: categories (geo: $geo, timePeriod: $timePeriod) {
    sicCode
    name
    locations
    visits
    brands {
      id
      name
      locations
      visits
    }
  }
}`

export const GET_TOP_10_BRAND_QUERY = `query GetTopCategoriesBrands ($geo: GeoInputType!, $timePeriod: TimePeriod!, $brandId: Int!, $sicCode: String!) {
  categories: categories (geo: $geo, timePeriod: $timePeriod) {
    sicCode
    name
    locations
    visits
    brands {
      id
      name
      locations
      visits
    }
  }
  brand: brand(geo: $geo, timePeriod: $timePeriod, brandId: $brandId, sicCode: $sicCode){
    id
    name
    locations
    visits
    sicCode
    category {
      sicCode
      name
      locations
      visits
    }
  }
}`

export const GET_TOP_10_CAT_QUERY = `query GetTopCategoriesBrands ($geo: GeoInputType!, $timePeriod: TimePeriod!, $sicCode: String!) {
  categories: categories (geo: $geo, timePeriod: $timePeriod) {
    sicCode
    name
    locations
    visits
    brands {
      id
      name
      locations
      visits
    }
  }
  category: category(sicCode: $sicCode, geo: $geo, timePeriod: $timePeriod) {
    sicCode
    name
    locations
    visits
    brands {
      visits
      locations
      name
      id
    }
  }
}`

export const SEARCH_QUERY = `query SearchBrandsCategoriesLocationGroups ($text : String!) {
  search(text: $text) {
    brands {
      id
      name
    }
    categories {
      sicCode
      name
    }
    locationGroups {
      id
      name
    }
    pois {
      id
      name
      address
      city
      state
      zip
      status
      latitude
      longitude
    }
  }
}`

export const GET_BRAND_QUERY = `query getBrandDetails($brandId: Int!, $sicCode: String!, $geo: GeoInputType!, $timePeriod: TimePeriod!) {
  brand(brandId: $brandId, sicCode: $sicCode, geo: $geo, timePeriod: $timePeriod) {
    id
    name
    locations
    visits
    sicCode
    category {
      sicCode
      name
      locations
      visits
    }
  }
}
`

export const GET_CAT_QUERY = `query GetCategoryDetails($sicCode: String!, $geo: GeoInputType!, $timePeriod: TimePeriod!) {
  category(sicCode: $sicCode, geo: $geo, timePeriod: $timePeriod) {
    sicCode
    name
    locations
    visits
    brands {
      visits
      locations
      name
      id
    }
  }
}`

export const GET_BRAND_POI = `query GetBrandPoiLocations($brandId:Int!, $sicCode:String!, $geo:GeoInputType! ,$timePeriod:TimePeriod!) {
  brand(brandId: $brandId, sicCode: $sicCode, geo: $geo, timePeriod: $timePeriod) {
    id
    name
    locations
    pois {
      id
      name
      address
      city
      state
      zip
      status
      latitude
      longitude
    }
  }
}`

export const GET_BRAND_WISE_DETAILS = `query BrandGeoWiseDetails($brandId: Int!, $timePeriod: TimePeriod!){
  STATE: brandGeoWiseDetails(brandId: $brandId, geoType: STATE,  timePeriod: $timePeriod){
      geos { 
        id
        locationCount
        visits 
      } 
  }
  DMA: brandGeoWiseDetails(brandId: $brandId, geoType: DMA, timePeriod: $timePeriod){
    geos {
      id
      locationCount
      visits
    }
  }
}`

export const GET_CATEGORY_WISE_DETAILS = `query CategoryGeoWiseDetails($sicCode: String!, $timePeriod: TimePeriod!){
  STATE: categoryGeoWiseDetails(sicCode: $sicCode, geoType: STATE, timePeriod: $timePeriod){
      geos {
        id
        locationCount
        visits 
      } 
  }
  DMA: categoryGeoWiseDetails(sicCode: $sicCode, geoType: DMA, timePeriod: $timePeriod){
    geos {
      id
      locationCount
      visits
    }
  }
}`
